<template>
    <header
        class="l-header"
        :class="{ 'is-static' : isStatic }"
    >
        <div class="l-header__inner l-grid">

            <router-link
                :to="inAdmin ? ROUTES.ADMIN.ROOT : ROUTES.HOME"
                class="l-header__logo"
                aria-label="Page d'accueil"
            >
                <Icon icon="logo"/>
            </router-link>

            <button
                class="l-header__burger | o-burger"
                :aria-label="isOpen ? 'Fermer le menu' : 'Ouvrir le menu'"
                @click="isOpen = !isOpen"
            >
                <span class='o-burger__line'></span>
                <span class='o-burger__line'></span>
                <span class='o-burger__line'></span>
                <span class='o-burger__cross'></span>
            </button>

            <slot/>
        </div>
    </header>
</template>

<script>
import debounce from 'node_modules/lodash/debounce';

import Icon from 'templates/objects/Icon';
import Link from 'templates/objects/Link';

export default {
    name: 'Header',
    components: {
        Icon,
        Link,
    },
    data() {
        return {
            isStatic: true,
            isOpen: false,
            scrollTop: 0,
            W: {},
        };
    },
    methods: {
        setSizes() {
            this.W = {
                w: window.innerWidth,
                h: window.innerHeight,
            };
            this.height = this.$el.offsetHeight;
        },
        onScroll() {
            this.isStatic = window.scrollY < this.height / 2;
        },
        onResize() {
            this.setSizes();
            this.onScroll();
        },
        open() {
            document.body.classList.add('has-menu-open');
            this.scrollTop = window.scrollY;

            this.isOpen = true;
        },
        close() {
            document.body.classList.remove('has-menu-open');
            setTimeout(() => {
                window.scrollTo(0, this.scrollTop);
            }, 5);

            this.isOpen = false;
        },
    },
    computed: {
        inAdmin() {
            return this.$route.name === 'dashboard' || this.$route.name === 'settings' || (this.$store.getters.isLogin && (this.$route.name == 'question' || this.$route.name == 'result' || this.$route.name == 'principe'))
        }
    },
    watch: {
        isOpen(open) {
            if (open) {
                this.open();
            } else {
                this.close();
            }
        },
        $route() {
            this.close();
        },
    },
    created() {
        this.onScroll = this.onScroll.bind(this);
        this.onResize = this.onResize.bind(this);

        // Window events
        window.addEventListener('scroll', this.onScroll);
        window.addEventListener('resize', debounce(this.onResize, 100));
    },
    mounted() {
        this.setSizes();
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.onScroll);
    },
};
</script>
